import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Route } from "react-router-dom";
import { OrganizationContent } from "../components";
import ApplicationList from "./ApplicationList";
import BillingInformation from "./Information";
import BillingInvoices from "./Invoices";
import { BillingTab, BillingTabs } from "./style";
import { PATH_APP } from "@/routes/paths";
import { useTranslation } from "react-i18next";

export default function OrganizationBilling() {
	const { t } = useTranslation();
	const history = useHistory();
	const { pathname } = useLocation();
	const [tab, setTab] = useState<string>("applicationList");

	const handleChangeTab = (e: React.SyntheticEvent, value: string) => {
		history.push(`/organization/billing/${value}`);
	};

	useEffect(() => {
		const pathArr = pathname.split("/");
		const path = pathArr[pathArr.length - 1];

		setTab(path);
	}, [pathname]);

	return (
		<OrganizationContent title={t("organization_billing.title")}>
			<Box sx={{ borderBottom: 1, borderColor: "#e0e0e0" }}>
				<BillingTabs value={tab} onChange={handleChangeTab}>
					{/* <BillingTab
						to="/organization/billing/information"
						label="정보"
						value="information"
					/> */}
					<BillingTab
						to="/organization/billing/applicationList"
						label={t("organization_billing.application_list_title")}
						value="applicationList"
					/>
					<BillingTab
						to="/organization/billing/invoices"
						label={t("organization_billing.invoices_title")}
						value="invoices"
					/>
				</BillingTabs>
			</Box>

			{/* <Route
				exact
				path={PATH_APP.organization.billing.information}
				component={BillingInformation}
			/> */}
			<Route
				exact
				path={PATH_APP.organization.billing.applicationList}
				component={ApplicationList}
			/>
			<Route
				exact
				path={PATH_APP.organization.billing.invoices}
				component={BillingInvoices}
			/>
		</OrganizationContent>
	);
}
